import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const namespaced = false

export default {
  namespaced,
  state: {
    user: {
      settlement_type: {}
    },
    userPending: false,
    promoUrl: '',
    promoWidget: '',
    tranches: {},
    mpcCode: ''
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account/index.js